module.exports = __webpack_public_path__ + "assets/russia.a88b0e51af8a56518f70654b3329b326.svg?";